import { INTERNAL_UNKNOWN } from '@utils/constants';

export const APP_VIEWER_SESSIONS_QUERY_CONFIG = {
  dimensions: ['app_user_id'],
  filter: [
    [
      {
        field: 'client_id',
        key: null,
        op: 'not_eq',
        value: INTERNAL_UNKNOWN,
        display: 'UNKNOWN',
        originalField: 'client_id',
      },
    ],
  ],
};

export const APP_VIEWER_SESSIONS_METRIC_FIELDS = ['AppTotalUserEvents'];
